import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { AcceptInvitationModel } from './model/AcceptInvitationModel';
import { AcceptInvitationController } from './controller/AcceptInvitationController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';
import { AuthCard } from '../AuthCard';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';

export class AcceptInvitationScene extends AScene<Props, AcceptInvitationModel, AcceptInvitationController> {

    private name: string = "";
    private password: string = "";

    public constructor(props: Props) {
        super(props);

        this.handleAcceptClicked = this.handleAcceptClicked.bind(this);
    }

    protected createControlller(): AcceptInvitationController {
        return new AcceptInvitationController();
    }

    private handleAcceptClicked() {
        this.controller.onAcceptClicked(this.name, this.password);
    }

    public render(): React.ReactNode {
        if (this.model.isInit) {
            return (<></>);
        }

        if (!this.model.valid) {
            return (
                <AuthCard title="Accept invitation" error={this.model.globalError}>
                    <div style={{ textAlign: 'center', marginTop: '8px' }}>
                        <a href="/login.rsc" style={{ color: '#009155' }}>Go to login</a>
                    </div>
                </AuthCard>
            );
        }

        this.name = this.model.name;
        this.password = this.model.password;

        return (
            <AuthCard title="Accept invitation" error={this.model.globalError}>
                <div style={{ textAlign: 'center', fontSize: '15px', color: '#888', marginBottom: '24px' }}>
                    You've been invited to join <b>{this.model.company}</b>.
                </div>
                <TextField label="Email" value={this.model.email} desc="You can not change this." />
                <TextField label="Name" value={this.model.name} error={this.model.nameError} onChange={(v) => { this.name = v; }} />
                <TextField label="Password" type="password" value={this.model.password} error={this.model.passwordError} onChange={(v) => { this.password = v; }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '8px' }}>
                    <Button color="primary" variant="contained" onClick={this.handleAcceptClicked}>Accept</Button>
                </div>
            </AuthCard>
        );
    }

}

export class Props {

}

export class AcceptInvitationSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return (
            <AcceptInvitationScene />
        );
    }

}
